<template>
  <div class="main-container container-fluid h-100">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <!-- Group above -->
    <div :class="['group-above', isCsvResult ? 'justify-content-end' : '']">
      <div class="group-breadcrumb" v-if="!isCsvResult">
        <!-- Start check mapping WMS -->
        <div :class="['label-mapping', { active: step == 1 }]">
          <h6 class="label" @click="handleChangeStep(1)">1.&emsp;{{ setting.wmsName }} の定義</h6>
        </div>
        <!-- End check mapping WMS -->
        <!-- Start check mapping SYSTEM -->
        <div
          :class="[
            'label-mapping',
            { active: step == 2 },
            isErrorMapping ? 'label-mapping-error' : ''
          ]"
        >
          <h6 class="label" @click="handleChangeStep(2)">2.&emsp;{{ setting.isName }} に紐づけ</h6>
          <i
            class="material-icons report"
            v-if="isErrorMapping"
            >report</i
          >
        </div>
        <!-- End check mapping SYSTEM -->
      </div>
    </div>
    <div class="block-right">
      <div class="common-mapping-screen">
        <template v-if="step == 1">
          <!-- Start table mapping WMS -->
          <CommonWmsFieldDefinition
            v-if="!isCsvResult"
            ref="commonWmsFieldDefinition"
            :mapping-no="mappingNo"
            :setting="setting"
            @isLoading="isLoadingEmit"
            @check-wms-item-mapped="
              event => {
                this.checkWmsListItems = event.checkWmsListItems
              }
            "
          />
        </template>
        <!-- End table mapping WMS -->
        <template v-if="step == 2">
          <!-- Start table mapping SYSTEM -->
          <CommonIsFieldMapping
            ref="commonIsFieldMapping"
            :mapping-no="mappingNo"
            :setting="setting"
            @isLoading="isLoadingEmit"
            @check-mst-item-mapped="
              event => {
                this.checkWmsListItems = event.checkWmsListItems
                this.isErrorMapping = event.isErrorMapping
              }
            "
          />
          <!-- End table mapping SYSTEM -->
        </template>
        <CommonCsvFieldDefinition
          v-if="isCsvResult"
          ref="CommonCsvFieldDefinition"
          :mapping-no="mappingNo"
          @isLoading="isLoadingEmit"
        />
      </div>
      <hr class="ml-3 m-0" />
      <div id="mapping-btn-group" :class="['btn-group', !isCsvResult && step == 1 ? 'flex-row-reverse' : '']">
        <b-button
          class="btn_white"
          id="save_and_next"
          v-if="!isCsvResult && step == 1"
          @click="handleChangeStep(1, true)"
        >
          {{ '保存して次へ' }}
        </b-button>
        <b-button
          class="btn_white"
          v-if="!isCsvResult && step == 2"
          @click="handleChangeStep(-1, true)"
        >
          {{ '保存して前へ' }}
        </b-button>
        <b-button :class="[(step == 1 && !checkWmsListItems && !isCsvResult) ? 'd-none' : 'btn_blue']" @click="saveMapping">
          保存
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import mixinAutoResize from '../../mixins/autoResize.js'
import EditableLabel from '../custom-components/EditableLabel'
import CommonWmsFieldDefinition from './CommonWmsFieldDefinition.vue'
import CommonIsFieldMapping from './CommonIsFieldMapping.vue'
import CommonFieldMappingModal from './CommonFieldMappingModal.vue'
import CommonCsvFieldDefinition from './CommonCsvFieldDefinition.vue'
import Loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'
import RouterUtils from '../../_helpers/router.util.js'
import FlashMessage from '../../common/flash-message.component.js'
import CssUtils from '../../_helpers/css.util.js'
import AppConstants from '../../constants/app.constants.js'
export default {
  mixins: [mixinAutoResize],
  props: {
    mappingNo: String
  },
  components: {
    EditableLabel,
    Loading,
    CommonWmsFieldDefinition,
    CommonIsFieldMapping,
    CommonFieldMappingModal,
    CommonCsvFieldDefinition
  },
  data() {
    return {
      setting: {},
      wmsItemList: [],
      mstItemList: [],
      isLoading: false,
      step: 1,
      checkWmsListItems: false,
      mappingSearch: null,
      selectedItems: [],
      originalMstItemList: [],
      stepParam: 'step',
      isErrorMapping: false
    }
  },
  async created() {
    await this.featchSettings()
    if (this.isCsvResult) {
      return
    }
    const params = document.location.href.match(/\?.+/)
    const objParam = RouterUtils.parseQueryToObject(params && params[0])
    this.step = (objParam && objParam.step) || 1
    RouterUtils.replaceUrlStr(`?${this.stepParam}=${this.step}`)
    window.addEventListener('resize', this.getCommonMappingHeadHeight)
  },
  mounted() {
    setTimeout(() => {
      this.getCommonMappingHeadHeight()
    }, 10)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getCommonMappingHeadHeight)
  },
  watch: {
    getMenuStatus() {
      this.getCommonMappingHeadHeight()
    },
    step() {
      setTimeout(() => {
        this.getCommonMappingHeadHeight()
      }, 10)
    }
  },
  computed: {
    ...mapGetters('settingWizardStore', ['getMenuStatus']),
    /** マッピングはcsv結果です */
    isCsvResult() {
      return this.mappingNo === 'result'
    }
  },
  methods: {
    /** 出力イベントの読み込みを取得する */
    isLoadingEmit(isLoading) {
      this.isLoading = isLoading
    },
    ...mapGetters('setting', ['getSetting']),
    /**
     * マッピングデータ保存処理
     */
    async saveMapping() {
      const step = this.parseStringToInt(this.step)
      let requestSaveMapping = null
      // Save csv mapping screen
      if (this.isCsvResult) {
        requestSaveMapping = await this.$refs['CommonCsvFieldDefinition'].saveCsvMapping()
        return
      }
      if (step === 1) {
        // Save WMS fields definition
        requestSaveMapping = await this.$refs['commonWmsFieldDefinition'].saveMapping()
      } else {
        // Save mapping
        requestSaveMapping = await this.$refs['commonIsFieldMapping'].saveMapping()
      }
      return requestSaveMapping
    },
    /** 設定データ取得 */
    async featchSettings() {
      const res = await this.getSetting()
      this.setting = res.data.mstSetting
    },
    async handleChangeStep(param, isButton = false) {
      let step = this.parseStringToInt(this.step)
      if (!isButton && param === step) {
        return
      }
      let requestSaveMapping = await this.saveMapping()
      if (!requestSaveMapping) {
        return
      }
      if (this.isErrorMapping && step === 2) {
        return
      }
      if (isButton) {
        step += param
      } else {
        step = param
      }
      this.step = step
      RouterUtils.replaceUrlStr(`?${this.stepParam}=${this.step}`)
      this.isErrorMapping = false
      FlashMessage.getInstance().hideAllErrorMessages()
    },
    parseStringToInt(paramStr) {
      return Number.parseInt(paramStr)
    },
    /**
     * 共通のマッピングヘッド高さを取得します。
     */
    getCommonMappingHeadHeight() {
      const commonMappingHead = document.getElementById('common-mapping-head')
      if (!commonMappingHead) {
        return
      }
      CssUtils.setCssVariable(AppConstants.COMMON_MAPPING_HEAD_HEIGHT_VARIABLE_NAME, commonMappingHead.clientHeight + 'px')
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  padding-left: 0px;
}
.main-container {
  display: flex;
  @include responsive-fs(16);
  color: #252422;
  background: #f8f8f8;
  padding-right: 0px;

  .group-above {
    margin-bottom: 5px;
    .group-breadcrumb {
      max-width: 320px;
      align-items: center;
      .label-mapping {
        display: flex;
        align-items: center;
        justify-content: start;
        padding: 0px 4px 0px 32px;
        gap: 2px;
        height: 62px;
        .report {
          color: #b41b3e;
          position: relative;
          bottom: 2px;
        }
        &.active {
          background: #FFFFFF;
        }
        .label {
          cursor: pointer;
          display: inline-block;
          text-align: center;
          font-weight: bold;
          padding-right: 5px;
          padding-left: 0px;
          margin-bottom: 4px;
          color: black;
          @include responsive-fs(14);
          overflow: hidden;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .label-mapping-error {
        .label {
          // 22px is width of icon report
          max-width: calc(100% - 22px);
        }
      }
    }
  }
  .block-right {
    flex: 1;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding-right: 16px;
    .common-mapping-screen {
      display: contents;
    }
    .btn-group {
      display: flex;
      align-items: center;
      justify-content: center;
      .btn_blue {
        flex-grow: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0px;
        min-width: 84px;
        min-height: 37px;
        border-radius: 4px;
        border: 2px solid #4e66a6;
        font-weight: bolder;
        @include responsive-fs(18);
      }
      .btn_white {
        border: none;
        flex-grow: 0;
        margin: 0 1rem;
        width: auto;
        padding: 0px;
        color: #4E66A6;
        @include responsive-fs(18);
        font-weight: 400;
        &:active {
          box-shadow: none;
          background: none;
        }
      }
    }
  }
  .small-text {
    @include responsive-fs(12);
    color: #252422;
  }
  a:hover {
    text-decoration: none;
  }
  /deep/ #scrollspy-mapping {
    .no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666563;
      font-weight: 400;
      @include responsive-fs(16);
      line-height: 24px;
      height: 100%;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CommonMasterMapping.vue